import Byconcept01 from './assets/byconcept-01.webp'
import Byconcept02 from './assets/byconcept-02.webp'
import Byconcept03 from './assets/byconcept-03.webp'
import Byconcept04 from './assets/byconcept-04.webp'
import Byconcept05 from './assets/byconcept-05.webp'
import Byconcept06 from './assets/byconcept-06.webp'
import ByconceptThumb from './assets/byconcept-thumb.webp'
import ByconceptLanding from './assets/byconcept-landing.webp'

import Subway01 from './assets/subway-01.png'
import Subway02 from './assets/subway-02.png'
import Subway03 from './assets/subway-03.png'
import Subway04 from './assets/subway-04.png'
import Subway05 from './assets/subway-05.png'
import SubwayThumb from './assets/subway-thumb.jpg'
import SubwayLanding from './assets/subway-landing.png'

import Protection01 from './assets/protection-01.png'
import Protection02 from './assets/protection-02.png'
import Protection03 from './assets/protection-03.png'
import Protection04 from './assets/protection-04.png'
import Protection05 from './assets/protection-05.png'
import ProtectionThumb from './assets/protection-thumb.jpg'
import ProtectionLanding from './assets/protection-landing.png'

import Passion01 from './assets/passion-01.png'
import Passion02 from './assets/passion-02.png'
import Passion03 from './assets/passion-03.png'
import Passion04 from './assets/passion-04.png'
import Passion05 from './assets/passion-05.png'
import Passion06 from './assets/passion-06.png'
import Passion07 from './assets/passion-07.png'
import Passion08 from './assets/passion-08.png'
import PassionThumb from './assets/passion-thumb.jpg'
import PassionLanding from './assets/passion-landing.png'

import Hypnose01 from './assets/hypnose-01.png'
import Hypnose02 from './assets/hypnose-02.png'
import Hypnose03 from './assets/hypnose-03.png'
import Hypnose04 from './assets/hypnose-04.png'
import Hypnose05 from './assets/hypnose-05.png'
import Hypnose06 from './assets/hypnose-06.png'
import HypnoseThumb from './assets/hypnose-thumb.jpg'
import HypnoseLanding from './assets/hypnose-landing.png'

import Illus01 from './assets/illus-01.webp'
import Illus02 from './assets/illus-02.webp'
import Illus03 from './assets/illus-03.webp'
import Illus04 from './assets/illus-04.webp'
import Illus05 from './assets/illus-05.webp'
import Illus06 from './assets/illus-06.webp'
import Illus07 from './assets/illus-07.webp'
import Illus08 from './assets/illus-08.webp'
import IllusThumb from './assets/illus-thumb.webp'
import IllusLanding from './assets/illus-landing.webp'

import Realease01 from './assets/realease-01.png'
import Realease02 from './assets/realease-02.png'
import Realease03 from './assets/realease-03.png'
import Realease04 from './assets/realease-04.png'
import RealeaseThumb from './assets/realease-thumb.jpg'
import RealeaseLanding from './assets/realease-landing.png'

import Organilog01 from './assets/organilog-01.png'
import Organilog02 from './assets/organilog-02.png'
import Organilog03 from './assets/organilog-03.png'
import Organilog04 from './assets/organilog-04.png'
import Organilog05 from './assets/organilog-05.png'
import Organilog06 from './assets/organilog-06.png'
import Organilog07 from './assets/organilog-07.png'
import OrganilogThumb from './assets/organilog-thumb.jpg'
import OrganilogLanding from './assets/organilog-landing.png'

import Decidoc01 from './assets/decidoc-01.png'
import Decidoc02 from './assets/decidoc-02.png'
import Decidoc03 from './assets/decidoc-03.png'
import Decidoc04 from './assets/decidoc-04.png'
import Decidoc05 from './assets/decidoc-05.png'
import Decidoc06 from './assets/decidoc-06.png'
import DecidocThumb from './assets/decidoc-thumb.jpg'
import DecidocLanding from './assets/decidoc-landing.png'

import Histoire01 from './assets/histoire-01.png'
import Histoire02 from './assets/histoire-02.png'
import Histoire03 from './assets/histoire-03.png'
import Histoire04 from './assets/histoire-04.png'
import Histoire05 from './assets/histoire-05.png'
import Histoire06 from './assets/histoire-06.png'
import Histoire07 from './assets/histoire-07.png'
import Histoire08 from './assets/histoire-08.png'
import HistoireThumb from './assets/histoire-thumb.jpg'
import HistoireLanding from './assets/histoire-landing.png'

import Dentaire01 from './assets/dentaire-01.png'
import Dentaire02 from './assets/dentaire-02.png'
import Dentaire03 from './assets/dentaire-03.png'
import Dentaire04 from './assets/dentaire-04.png'
import DentaireThumb from './assets/dentaire-thumb.jpg'
import DentaireLanding from './assets/dentaire-landing.png'

import Mamanvogue01 from './assets/mamanvogue-01.webp'
import Mamanvogue02 from './assets/mamanvogue-02.webp'
import Mamanvogue03 from './assets/mamanvogue-03.webp'
import Mamanvogue04 from './assets/mamanvogue-04.webp'
import Mamanvogue05 from './assets/mamanvogue-05.webp'
import MamanvogueThumb from './assets/mamanvogue-thumb.webp'
import MamanvogueLanding from './assets/mamanvogue-landing.webp'

import Alpaga01 from './assets/alpaga-01.png'
import Alpaga02 from './assets/alpaga-02.png'
import Alpaga03 from './assets/alpaga-03.png'
import Alpaga04 from './assets/alpaga-04.png'
import Alpaga05 from './assets/alpaga-05.png'
import Alpaga06 from './assets/alpaga-06.png'
import AlpagaThumb from './assets/alpaga-thumb.jpg'
import AlpagaLanding from './assets/alpaga-landing.png'

export default {
  byconcept: {
    description: `Réalisation de 3 covers pour l'ebook de By Concept sur le thème du coffee shop. Illustration et mise en page.`,
    fields: [
      'Direction artistique',
      'Illustration',
      'Packaging',
    ],
    imgSet: [
      { src: Byconcept01, alt: `Trois pistes de couverture pour le livre 100 idées de Coffee Shop` },
      { src: Byconcept02, alt: `Mockup du livre 100 idées de Coffee Shop - Piste 1` },
      { src: Byconcept03, alt: `Mockup du livre 100 idées de Coffee Shop - Piste 2` },
      { src: Byconcept04, alt: `Illustration du logo tasse de café` },
      { src: Byconcept05, alt: `Mockup du livre 100 idées de Coffee Shop - Piste 3` },
      { src: Byconcept06, alt: `Sketching des pistes de couverture pour le livre 100 idées de Coffee Shop` },
    ],
    landingImg: { backgroundImage: `url(${ByconceptLanding})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' },
    title: 'By Concept',

    thumbImg: { src: SubwayThumb, alt: 'Subway' },
    next: 'subway',
  },

  subway: {
    description: `Refonte de la home de Subway et nouvelle direction artistique web.`,
    fields: [
      'Direction artistique',
      'Webdesign',
      'Refonte',
    ],
    imgSet: [
      { src: Subway01, alt: `Header Subway` },
      { src: Subway02, alt: `Séparateur Subway` },
      { src: Subway03, alt: `Témoignages Subway24` },
      { src: Subway04, alt: `Footer Subway` },
      { src: Subway05, alt: `Mockup Subway` },
    ],
    landingImg: { backgroundImage: `url(${SubwayLanding})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' },
    title: 'Subway',

    thumbImg: { src: ProtectionThumb, alt: 'Protection 24' },
    next: 'protection',
  },

  protection: {
    description: `Refonte du site de Protection 24 - BNP Paribas en desktop + responsive et création du site P24 Connect.`,
    fields: [
      'Direction artistique',
      'Responsive Webdesign',
      'Ergonomie',
    ],
    imgSet: [
      { src: Protection01, alt: `Homepage p24` },
      { src: Protection02, alt: `Logo p24` },
      { src: Protection03, alt: `Infographie p24` },
      { src: Protection04, alt: `Mockup desktop/mobile p24` },
      { src: Protection05, alt: `About p24` },
    ],
    landingImg: { backgroundImage: `url(${ProtectionLanding})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' },
    title: 'Protection 24',

    thumbImg: { src: PassionThumb, alt: 'Nantes Passion' },
    next: 'passion',
  },

  passion: {
    description: `Création du mini-site de Nantes Passion en desktop et responsive pour le lancement du nouveau numéro de septembre.`,
    fields: [
      'Direction artistique',
      'Responsive Webdesign',
      'Ergonomie',
    ],
    imgSet: [
      { src: Passion01, alt: `Homepage Nantes Passion` },
      { src: Passion02, alt: `Logo guillemet jaune` },
      { src: Passion03, alt: `Workflow Nantes Passion` },
      { src: Passion04, alt: `Logo guillemet noir` },
      { src: Passion05, alt: `Footer Nantes Passion` },
      { src: Passion06, alt: `Logo complet Nantes Passion` },
      { src: Passion07, alt: `Mockup dekstop Nantes Passion` },
      { src: Passion08, alt: `Mockup iPad Nantes Passion` },
    ],
    landingImg: { backgroundImage: `url(${PassionLanding})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' },
    title: `Nantes Passion`,

    thumbImg: { src: HypnoseThumb, alt: `Nantes Hypnose` },
    next: 'hypnose',
  },

  hypnose: {
    description: `Création d'un logo et d'une identité visuelle pour Nantes Hypnose sur base d'un monde imaginaire et onirique.`,
    fields: [
      'Direction artistique',
      'Logo et identité visuelle',
      'Illustration',
    ],
    imgSet: [
      { src: Hypnose01, alt: `Variantes logo Nantes Hypnose` },
      { src: Hypnose02, alt: `Logo complet avec fond Nantes Hypnose` },
      { src: Hypnose03, alt: `Logo final Nantes Hypnose` },
      { src: Hypnose04, alt: `Logo complet pour le web Nantes Hypnose` },
      { src: Hypnose05, alt: `Mockup print Nantes Hypnose` },
      { src: Hypnose06, alt: `Sketchs préparatoires Nantes Hypnose` },
    ],
    landingImg: { backgroundImage: `url(${HypnoseLanding})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' },
    title: `Nantes Hypnose`,

    thumbImg: { src: IllusThumb, alt: `Illustrations` },
    next: 'illus',
  },

  illus: {
    description: `Sélection d'illustrations traditionnelles (encre, plume et crayons) et numériques (tablette graphique sur Procreate et Clip Studio).`,
    fields: [
      'Ilustration',
      'Direction artistique',
      'Character Design',
    ],
    imgSet: [
      { src: Illus01, alt: `Gon de Hunter x Hunter (manga)` },
      { src: Illus02, alt: `Spike Spiegel de Cowboy Bebop et Haku de Naruto (manga aesthetic)` },
      { src: Illus03, alt: `PlayStation et GameBoy (aesthetic)` },
      { src: Illus04, alt: `Super Nintendo / Super Famicom / SNES (aesthetic)` },
      { src: Illus05, alt: `Hashirama Senju et Madara Uchiwa de Naruto (manga aesthetic)` },
      { src: Illus06, alt: `Tsunade de Naruto et Alex Louis Armstrong de Full Metal Alchemist (mangas)` },
      { src: Illus07, alt: `Alphonse Elric de Full Metal Alchemist et Haku de Naruto (mangas)` },
      { src: Illus08, alt: `L de Death Note (mangas)` },
    ],
    landingImg: { backgroundImage: `url(${IllusLanding})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' },
    title: 'Illustrations',

    thumbImg: { src: RealeaseThumb, alt: `Realease Capital` },
    next: 'realease',
  },

  realease: {
    description: `Refonte de la home en landing page et nouvelle direction artistique web.`,
    fields: [
      'Direction artistique',
      'Webdesign',
      'Refonte',
    ],
    imgSet: [
      { src: Realease01, alt: `Landing page Realease Capital` },
      { src: Realease02, alt: `Offres Realease Capital` },
      { src: Realease03, alt: `About Realease Capital` },
      { src: Realease04, alt: `Footer Realease Capital` },
    ],
    landingImg: { backgroundImage: `url(${RealeaseLanding})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' },
    title: 'Realease Capital',

    thumbImg: { src: OrganilogThumb, alt: 'Organilog' },
    next: 'organilog',
  },

  organilog: {
    description: `Refonte, ergonomie et nouvelle direction artistique de la home et du formulaire d'inscription.`,
    fields: [
      'Direction artistique',
      'Webdesign',
      'Refonte',
    ],
    imgSet: [
      { src: Organilog01, alt: `Homepage Organilog 01` },
      { src: Organilog02, alt: `Homepage Organilog 02` },
      { src: Organilog03, alt: `Homepage Organilog 03` },
      { src: Organilog04, alt: `Homepage Organilog 04` },
      { src: Organilog05, alt: `Footer Organilog` },
      { src: Organilog06, alt: `Formulaires d'inscription Organilog` },
      { src: Organilog07, alt: `Mockup mobile Organilog` },
    ],
    landingImg: { backgroundImage: `url(${OrganilogLanding})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' },
    title: 'Organilog',

    thumbImg: { src: DecidocThumb, alt: 'Decidoc' },
    next: 'decidoc',
  },

  decidoc: {
    description: `Refonte de la home page de Decidoc, plateforme médicale pour professionnels de la santé.`,
    fields: [
      'Direction artistique',
      'Webdesign',
      'Refonte',
    ],
    imgSet: [
      { src: Decidoc01, alt: `Mockup web de la page d'accueil du site Decidoc` },
      { src: Decidoc02, alt: `Logo Decidoc` },
      { src: Decidoc03, alt: `Mockup web de la page about du site Decidoc` },
      { src: Decidoc04, alt: `Mockup web de la page about du site Decidoc 02` },
      { src: Decidoc05, alt: `Mockup web de la page about du site Decidoc 03` },
      { src: Decidoc06, alt: `Mockup web de la page contact du site Decidoc` },
    ],
    landingImg: { backgroundImage: `url(${DecidocLanding})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' },
    title: 'Decidoc',

    thumbImg: { src: HistoireThumb, alt: `Museum d'Histoire Naturelle Nantes` },
    next: 'histoire',
  },

  histoire: {
    description: `Projet de refonte du site du Musée d’histoire naturelle de Nantes en desktop et responsive. Création d’illustrations et du logo.`,
    fields: [
      'Direction artistique et identité visuelle',
      'Responsive Webdesign',
      'Ergonomie',
    ],
    imgSet: [
      { src: Histoire01, alt: `Logo Museum d'Histoire Naturelle` },
      { src: Histoire02, alt: `Carte Museum d'Histoire Naturelle` },
      { src: Histoire03, alt: `Plan page d'accueil Museum d'Histoire Naturelle` },
      { src: Histoire04, alt: `Homepage Museum d'Histoire Naturelle` },
      { src: Histoire05, alt: `Menu Museum d'Histoire Naturelle` },
      { src: Histoire06, alt: `Collection Museum d'Histoire Naturelle` },
      { src: Histoire07, alt: `Collection Hover Museum d'Histoire Naturelle` },
      { src: Histoire08, alt: `About Museum d'Histoire Naturelle` },
    ],
    landingImg: { backgroundImage: `url(${HistoireLanding})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' },
    title: `Museum d'Histoire Naturelle Nantes`,

    thumbImg: { src: DentaireThumb, alt: 'Information Dentaire' },
    next: 'dentaire',
  },

  dentaire: {
    description: `Refonte, ergonomie et nouvelle direction artistique de la home et de la page article.`,
    fields: [
      'Direction artistique',
      'Webdesign',
      'Refonte',
    ],
    imgSet: [
      { src: Dentaire01, alt: `Home Information Dentaire 01` },
      { src: Dentaire02, alt: `Home Information Dentaire 02` },
      { src: Dentaire03, alt: `Home Information Dentaire 03` },
      { src: Dentaire04, alt: `Page Article Information Dentaire` },
    ],
    landingImg: { backgroundImage: `url(${DentaireLanding})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' },
    title: `Information Dentaire`,

    thumbImg: { src: MamanvogueThumb, alt: 'Maman Vogue' },
    next: 'mamanvogue',
  },

  mamanvogue: {
    description: `Nouvelle identité visuelle et charge graphique pour le blog Maman Vogue, ainsi que refonte graphique du site web en responsive.`,
    fields: [
      'Direction artistique',
      'Webdesign',
      'Identité visuelle',
    ],
    imgSet: [
      { src: Mamanvogue01, alt: `Carte de visite` },
      { src: Mamanvogue02, alt: `Ensemble de mockups` },
      { src: Mamanvogue03, alt: `Mockup desktop 01` },
      { src: Mamanvogue04, alt: `Mockup desktop 02` },
      { src: Mamanvogue05, alt: `Mockup smartphone` },
    ],
    landingImg: { backgroundImage: `url(${MamanvogueLanding})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' },
    title: 'Maman Vogue',

    thumbImg: { src: AlpagaThumb, alt: 'Quatre mille chic alpaga' },
    next: 'alpaga',
  },

  alpaga: {
    description: `3 pistes créatives différentes pour la création d’un logo pour la marque Quatre Mille - Chic Alpaga, marque de vêtements pour bébés et femmes enceintes. `,
    fields: [
      'Direction artistique',
      'Identité visuelle',
      'Logo',
    ],
    imgSet: [
      { src: Alpaga01, alt: `Première version du logo Quatre Mille Chic Alpaga` },
      { src: Alpaga02, alt: `Mockups print avec la première version du logo Quatre Mille Chic Alpaga` },
      { src: Alpaga03, alt: `Deuxième version du logo Quatre Mille Chic Alpaga` },
      { src: Alpaga04, alt: `Mockups print avec la deuxième version du logo Quatre Mille Chic Alpaga` },
      { src: Alpaga05, alt: `Troisième version du logo Quatre Mille Chic Alpaga` },
      { src: Alpaga06, alt: `Mockups print avec la troisième version du logo Quatre Mille Chic Alpaga` },
    ],
    landingImg: { backgroundImage: `url(${AlpagaLanding})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' },
    title: 'Quatre mille chic alpaga',

    thumbImg: { src: ByconceptThumb, alt: 'By Concept' },
    next: 'byconcept',
  },
}



// WEBPACK FOOTER //
// ./src/work-data.js